import Axios from "axios";
import { API_URL } from "../../../DesktopApp";

const getCandidateStatus = async () => {
  try {
    const response = await Axios.post(
      `${API_URL}/status/getAllCandidateStatus`
    );
    // const response = await Axios.post('http://localhost:3004/status/getAllStatus');
    return response;
  } catch (err) {
    return err;
  }
};

const assignCandidate = async (candidate_id, user, status) => {
  try {
    const response = await Axios.post(
      `${API_URL}/desktop/assigncandidates/assigncandidate`,
      {
        c_id: candidate_id,
        assign_uid: user,
        status: status,
      }
    );
    return response;
  } catch (err) {
    return err;
  }
};

const getAssignUser = async () => {
  try {
    const response = await Axios.post(`${API_URL}/users/getUserList`);
    return response;
  } catch (err) {
    return err;
  }
};

export { assignCandidate, getAssignUser, getCandidateStatus };
